<template>
  <main style="opacity: 0;">
    <div class="block">
      <Paragraph
        size="small"
        :text="structure[0].eyelet"
        class="block__eyelet"
        data-anim="fade"
        data-view="false"
      />
      <Counter
        number="03"
        data-anim="fade"
        data-view="false"
      />
      <div data-nav="investimenti">
        <Title
          :size="structure[0].titleSize"
          :text="structure[0].title"
          data-anim="title"
          data-view="false"
          data-siblings
        />
      </div>

      <div class="block__content">
        <Paragraph
          :size="structure[0].textSize"
          :text="structure[0].text"
          data-anim="text"
          data-view="false"
        />
      </div>
      <List :slots="slots" type="project">
        <a
          v-for="(project, index) in this.projects"
          :key="index"
          :href="project.link"
          :slot="`slot-${index}`"
          :data-nav="project.id"
          :aria-label="project.title"
          data-project="true"
          @click.prevent="$goTo(project.link, 'parent-child');"
          @mouseenter="hover"
          @mouseleave="hover"
        >
          <Title
            size="normal"
            :text="project.title"
            data-anim="title"
            data-view="false"
          />
        </a>
      </List>
    </div>
  </main>
</template>

<script>
import utils from '@/scripts/utils';
import { hovers } from '@/assets/animations';

import Counter from '@/components/text/Counter.vue';
import Title from '@/components/text/Title.vue';
import Paragraph from '@/components/text/Paragraph.vue';
import List from '@/components/text/List.vue';
import BulletList from '@/components/BulletList.vue';
import BlockText from '@/components/BlockText.vue';

export default {
  name: 'Projects',

  components: {
    Counter,
    Title,
    Paragraph,
    List,
    BulletList,
    BlockText,
  },

  data() {
    return {
      hoverAnim: {},
      width: '100%',
    };
  },

  computed: {
    structure() {
      const data = this.$store.state.firebase.investimenti;
      const { lang } = this.$store.state;
      const structure = data.structure[lang];
      const s = [];
      Object.keys(structure).forEach((key) => {
        s.push(structure[key].data);
      });
      return s;
    },

    projects() {
      const { childrens } = this.$store.state.firebase.investimenti;
      const { lang } = this.$store.state;
      const pathLang = lang === 'it' ? 'path' : 'pathEn';
      const p = [];
      Object.keys(childrens).forEach((key) => {
        const projectStructure = childrens[key].structure[this.$store.state.lang];
        const s = [];
        Object.keys(projectStructure).forEach((pkey) => {
          if (projectStructure[pkey].component === 'OneColumnText') {
            s.push(projectStructure[pkey].data);
          }
        });
        p.push({
          id: childrens[key][pathLang].substr(1),
          title: s[0].title,
          link: lang === 'it' ? `/${lang}/investimenti${childrens[key].path}` : `/${lang}/investments${childrens[key].pathEn}`,
          order: childrens[key].order,
        });
      });

      p.sort((a, b) => a.order - b.order);
      return p;
    },

    slots() {
      const s = [];
      this.projects.forEach((key, index) => {
        s.push(`slot-${index}`);
      });
      return s;
    },
  },

  mounted() {
    const discover = this.$el.querySelector('.discover');
    const line = this.$el.querySelector('.list__line');
    const widthD = discover.getBoundingClientRect().width;
    const widthL = line.getBoundingClientRect().width;
    this.width = widthL - widthD - 20;
  },

  methods: {
    hover(event) {
      if (utils.isTouchDevice()) return;
      const dir = event.type === 'mouseenter';
      const dataNav = event.target.dataset.nav;

      if (dir) {
        if (this.hoverAnim[dataNav] === undefined) this.hoverAnim[dataNav] = hovers.get('project')(event.target.parentNode, this.width);
        this.hoverAnim[dataNav].play();
      } else {
        this.hoverAnim[dataNav].reverse();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  & + .block {
    margin-top: rem(80px);
  }

  &__eyelet {
    margin-bottom: rem(70px);
  }

  &__content {
    p {
      margin-top: rem(100px);
    }
  }

  &__notes {
    padding-top: rem(100px);
    p {
      margin-top: rem(60px);
    }
  }
}
</style>
